import { useCallback, useRef } from 'react';
import { gtmServiceCompleteEvent, ServiceActionsType } from '~/utils/gtm-helpers';

const FLOW_START_TIME_KEY = 'gtm_flow_start_time';

export const markFlowStart = () => {
    sessionStorage.setItem(FLOW_START_TIME_KEY, Date.now().toString());
};

export const useTrackServiceComplete = () => {
    const hasFired = useRef(false);

    const triggerEvent = useCallback(
        (
            serviceName: string,
            serviceItems: string,
            serviceAction: ServiceActionsType,
            value: string
        ) => {
            // 1. Detect reload (Option 2)
            const [navigation] = performance.getEntriesByType(
                'navigation'
            ) as PerformanceNavigationTiming[];
            const isReload = navigation?.type === 'reload';

            // 2. Only fire if it's not a reload AND hasn't fired yet in this session
            if (!isReload && !hasFired.current) {
                const startTime = sessionStorage.getItem(FLOW_START_TIME_KEY);
                const completionTime = startTime
                    ? Math.round((Date.now() - parseInt(startTime, 10)) / 1000)
                    : 0;
                gtmServiceCompleteEvent(
                    serviceName,
                    serviceItems,
                    serviceAction,
                    value,
                    completionTime
                );
                hasFired.current = true;
            }
        },
        []
    );

    return { triggerEvent };
};
